import { FC } from 'react';

export const DropdownDivider: FC = () => <div className="my-1 h-px bg-gray-100 dark:bg-gray-600" />;
